export default __webpack_public_path__ + "static/Witcher-f172b24d0328769cb54c7334ab22e4cb.png";